<template>
  <div class="x-postcontent x-postcontent-0 clearfix">
    <div class="x-content-layout layout-item-0">
      <div class="x-content-layout-row">
        <div
          class="x-layout-cell layout-item-1"
          style="width: 100%"
          >
          <table class="x-article" style="width: 100%; ">
            <tbody>
              <tr>
                <td style="width: 100%; ">
                  <h1 class="header">
                      In Amsterdam
                  </h1>
                </td>
              </tr>
            </tbody>
          </table>
          <nav class="article-nav">
              <router-link class="article-link" to="/adam">Scheepswerven en droogdokken</router-link>
          </nav>
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
</style>

<script>
// @ is an alias to /src

export default {
  name: 'adverteren',
}
</script>
